import { Component, createSignal, createEffect, For } from 'solid-js';
import { t } from '@trimble/i18n';
import { LineWeightIcon } from '../line-weight-icon/LineWeightIcon';
import { LINE_THICKNESS_OPTIONS } from '../utils/layer-default-values';
import { closeDropdown } from '../utils/dropdown-utils';

export interface LineWeightSelectorProps {
  initialLineThickness: number;
  onLineThicknessChange(lineThickness: number): void;
}

export const LineWeightSelector: Component<LineWeightSelectorProps> = (
  props
) => {
  let lineThicknessDropdownWrapper: HTMLDivElement | undefined;

  const [currentLineThickness, setCurrentLineThickness] = createSignal<number>(
    props.initialLineThickness
  );

  createEffect(() => {
    setCurrentLineThickness(props.initialLineThickness);
  });

  const handleLineThicknessChange = (lineThickness: number): void => {
    if (lineThickness === currentLineThickness()) {
      closeDropdown(lineThicknessDropdownWrapper);
      return;
    }
    setCurrentLineThickness(lineThickness);
    props.onLineThicknessChange(lineThickness);
    closeDropdown(lineThicknessDropdownWrapper);
  };

  return (
    <div
      class="flex flex-col gap-1 flex-1"
      ref={(el) => {
        lineThicknessDropdownWrapper = el;
      }}
    >
      <label class="text-xs text-gray-6">{t('general.lineweight')}</label>
      <div class="border border-gray-2 rounded-md bg-white">
        <modus-wc-dropdown-menu
          button-variant="borderless"
          button-color="tertiary"
          menu-placement="bottom-end"
          class="w-full block rounded-md [&_modus-wc-button]:!w-full [&_modus-wc-button]:!block [&_button]:!w-full"
          disabled={false}
        >
          <div
            slot="button"
            class="flex items-center py-0.5 text-xs w-full justify-between"
          >
            <div class="flex items-center gap-2.5">
              <LineWeightIcon size="16" />
              <span class="text-gray-7">{currentLineThickness()}</span>
            </div>
            <modus-wc-icon name="expand_more" size="sm" />
          </div>
          <div slot="menu">
            <For each={LINE_THICKNESS_OPTIONS}>
              {(thickness) => (
                <modus-wc-menu-item
                  class="text-gray-7"
                  size="md"
                  label={thickness.toString()}
                  value={thickness.toString()}
                  on:itemSelect={(event) => {
                    const e = event as CustomEvent<{ value: string }>;
                    handleLineThicknessChange(
                      Number.parseInt(e.detail.value, 10)
                    );
                  }}
                />
              )}
            </For>
          </div>
        </modus-wc-dropdown-menu>
      </div>
    </div>
  );
};
